import { useState } from 'react';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import FilterListIcon from '@mui/icons-material/FilterList';
import ClearIcon from '@mui/icons-material/Clear';

interface Props {
  activeFilterCount: number;
  onClear: () => void;
  children: React.ReactNode;
}

export default function CollapsibleFilterBar({ activeFilterCount, onClear, children }: Props) {
  const [expanded, setExpanded] = useState(false);

  return (
    <Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <IconButton size="small" onClick={() => setExpanded(!expanded)} aria-label="Toggle filters">
          <FilterListIcon />
        </IconButton>
        <Typography variant="body2" component="div" sx={{ flex: 1 }}>
          Filters
          {activeFilterCount > 0 && (
            <Chip label={activeFilterCount} size="small" sx={{ ml: 1 }} color="primary" />
          )}
        </Typography>
        {activeFilterCount > 0 && (
          <IconButton size="small" onClick={onClear} aria-label="Clear filters">
            <ClearIcon fontSize="small" />
          </IconButton>
        )}
      </Box>
      <Collapse in={expanded}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, pl: 5, pt: 1 }}>
          {children}
        </Box>
      </Collapse>
    </Box>
  );
}
